import PropTypes from 'prop-types';
// @mui
import Container from '@mui/material/Container';
// routes
import { paths } from 'src/routes/paths';
// components
import { useSettingsContext } from 'src/components/settings';
import CustomBreadcrumbs from 'src/components/custom-breadcrumbs';
//
import OpTransactionReportForm from '../op-transaction-report-form';

// ----------------------------------------------------------------------

export default function OpTransactionReportView() {
  const settings = useSettingsContext();

  return (
    <Container maxWidth={settings.themeStretch ? false : 'xl'}>
      <CustomBreadcrumbs
        heading="Op Transaction Report"
        links={[
          {
            name: 'Dashboard',
            href: paths.dashboard.root,
          },
          { name: 'Report' },
          { name: 'Op Transaction' },
        ]}
        sx={{
          mb: { xs: 3, md: 5 },
        }}
      />

      <OpTransactionReportForm />
    </Container>
  );
}
